module.exports = __webpack_public_path__ + "static/media/icon-amex.2548a3df.png";